import { render, staticRenderFns } from "./ManualTaskPage.vue?vue&type=template&id=587edb15&scoped=true&"
import script from "./ManualTaskPage.vue?vue&type=script&lang=js&"
export * from "./ManualTaskPage.vue?vue&type=script&lang=js&"
import style0 from "./ManualTaskPage.vue?vue&type=style&index=0&id=587edb15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587edb15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VRow})
